export const validateJson = (value: string): boolean => {
  try {
    JSON.parse(value);
    return true;
  } catch (error) {
    return false;
  }
};

export const validateXml = (value: string): boolean => {
  try {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(value, "application/xml");
    const hasError = parsed.querySelector("parsererror");

    if (hasError) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

// Validation function for authValue FormItem to ensure it contains only valid base64 characters
// [A-Za-z0-9+/]+ Matches one or more Base64 characters (A–Z, a–z, 0–9, +, /)
// ={0,2} Allows for zero, one, or two padding characters (=) at the end of the string
export const validateBase64 = (value: string) => {
  if (!value) {
    return false;
  }

  const basicAuthPattern = /^[A-Za-z0-9+/]+={0,2}$/;
  if (!basicAuthPattern.test(value)) {
    return false;
  }

  return true;
};
